export default "__VITE_ASSET__46a09e00__"